import React from "react";
import FormProvider from "./FormProvider";
import useForm from "./useForm";
/**
 * Shorthand for creating a form context (via `useForm` and `<FormProvider>`) and `<form>`-wrapper.
 *
 * **Should not be used together with `useForm`.**
 *
 * Components inside the `<Form>` sub tree can use  `useFormApi` to obtain the `FormApi` instance.
 *
 * To obtain the state directly, use `useForm` together with `<FormProvider>`
 */
export default function Form({ defaultValues, children, langSet = "Form", onSubmit, }) {
    const { form, state } = useForm({ onSubmit, defaultValues, langSet });
    return (React.createElement(FormProvider, { form: form, state: state },
        React.createElement("form", { onSubmit: form.submit }, children)));
}
